import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-detail-inbox',
  templateUrl: './detail-inbox.page.html',
  styleUrls: ['./detail-inbox.page.scss'],
})
export class DetailInboxPage implements OnInit {

  constructor(private modalCtrl:ModalController, private navCtrl:NavController) { }

  ngOnInit() {
  }

  closeModal()
  {
    this.modalCtrl.dismiss();
  }

}
